<div class="preloader">
    <div class="preloader-progress">
        <div class="preloader-progress-bar"></div>
    </div>
</div>